import { TabStyles, TextFieldWidget } from '@tableau/widgets';
import React from 'react';

import { Messages } from '~src/codegen/Localize';
import { cssClass } from '~src/style';

import { DomainValidationStatus } from '../../types/DomainValidationStatus';

export type AddNewDomainTextFieldProps = Readonly<{
  onDomainNameChange: (domainName: string) => void;
  domainName: string;
  domainValidationStatus: DomainValidationStatus;
}>;

export function AddNewDomainTextField(props: AddNewDomainTextFieldProps) {
  const isValid = props.domainValidationStatus === DomainValidationStatus.NO_ERROR ? undefined : false;
  const errorMessage = getErrorMessageForDomainValidationStatus(props.domainValidationStatus);
  return (
    <TextFieldWidget
      label={Messages.bridgeSiteSettingsDomain()}
      onChange={e => props.onDomainNameChange(e.target.value)}
      onClear={() => props.onDomainNameChange('')}
      placeholder={''}
      testId={'domain-text-widget'}
      value={props.domainName}
      kind={'outline'}
      className={textFieldClass}
      style={{ width: '100%' }}
      valid={isValid}
      message={errorMessage}
    />
  );
}

function getErrorMessageForDomainValidationStatus(domainValidationStatus: DomainValidationStatus) {
  switch (domainValidationStatus) {
    case DomainValidationStatus.NO_ERROR:
      return '';
    case DomainValidationStatus.INVALID_CHARACTERS_ERROR:
      return Messages.bridgeSiteSettingsDomainValidationInvalidCharacters();
    case DomainValidationStatus.NOT_UNIQUE_ERROR:
      return Messages.bridgeSiteSettingsDomainValidationNotUnique();
    case DomainValidationStatus.WILDCARD_NOT_LEFTMOST_CHARACTER_ERROR:
      return Messages.bridgeSiteSettingsDomainValidationWildcardNotLeftmostCharacter();
    case DomainValidationStatus.WILDCARD_PERIOD_ERROR:
      return Messages.bridgeSiteSettingsDomainValidationWildcardPeriod();
    case DomainValidationStatus.DOMAIN_NAME_IS_DEFAULT:
      return Messages.bridgeSiteSettingsDomainValidationDefault();
    case DomainValidationStatus.DOMAIN_NAME_IS_BLOCKED:
      return Messages.bridgeSiteSettingsDomainValidationBlocked();
    case DomainValidationStatus.DOMAIN_NAME_MAXIMUM_CHARACTERS:
      return Messages.bridgeSiteSettingsDomainValidationMaxCharacter();
    case DomainValidationStatus.INVALID_DASHES_ERROR:
      return Messages.bridgeSiteSettingsDomainValidationInvalidDashes();
    case DomainValidationStatus.INVALID_UNDERSCORES_ERROR:
      return Messages.bridgeSiteSettingsDomainValidationInvalidUnderscores();
    case DomainValidationStatus.INVALID_FORMAT_ERROR:
      return Messages.bridgeSiteSettingsDomainValidationInvalidFormat();
    default:
      return Messages.errorUnknown();
  }
}

const textFieldClass = cssClass('add-new-domain-text-field', 'root', {
  width: '100%',
  marginTop: TabStyles.Spacing.ExtraLargeSpace,
  marginBottom: TabStyles.Spacing.LargeSpace,
});
